<ion-app class="ion-app">
  <ion-split-pane contentId="main-content">
    <ion-menu contentId="main-content" type="overlay" class="sidemenu" side="end" *ngIf="user">

      <ion-header class="ion-header">
        <ion-toolbar class="ion-toolbar">
          <ion-title>{{ 'sidemenu.menu' | translate }}</ion-title>
        </ion-toolbar>
      </ion-header>

      <ion-content class="ion-content">

          <ion-list lines="full">

            <lang-selector [showLabel]="true"></lang-selector>

            <ion-menu-toggle autoHide="false">
              <ion-item [routerDirection]="'forward'" [routerLink]="[p.url]" *ngFor="let p of appPages">
                <ion-icon slot="start" [name]="p.icon"></ion-icon>
                <ion-label class="ion-label">
                  {{p.title}}
                </ion-label>
              </ion-item>
            </ion-menu-toggle>
            <ion-item (click)="toggleSubmenu()">
              <ion-icon name="arrow-dropright" slot="start" *ngIf="!showSubmenu"></ion-icon>
              <ion-icon name="arrow-dropdown" slot="start" *ngIf="showSubmenu"></ion-icon>
              <ion-label class="ion-label">
                {{ 'sidemenu.services' | translate }}
              </ion-label>
              <ion-spinner name="crescent" *ngIf="loadingServices"></ion-spinner>
              <ion-badge color="light" slot="end">{{ servicesPages.length }}</ion-badge>
            </ion-item>
            <ion-item-group  class="dropdown-menu" [ngClass]="showSubmenu ? 'visible' : 'hidden'">
              <ion-menu-toggle autoHide="false">
                <ion-item *ngFor="let service of servicesPages" lines="none" [routerLink]="['/service-details', service.id]" routerDirection="root" >
                  <ion-icon name="ios-return-right" slot="start"></ion-icon>
                  <ion-label class="ion-label">
                    {{ service.name }}
                  </ion-label>
                </ion-item>
              </ion-menu-toggle>
            </ion-item-group>
            <ion-menu-toggle autoHide="false">
              <ion-item [routerDirection]="'forward'" [routerLink]="[p.url]" *ngFor="let p of appPages2">
                <ion-icon slot="start" [name]="p.icon"></ion-icon>
                <ion-label class="ion-label">
                  {{p.title | translate }}
                </ion-label>
              </ion-item>
            </ion-menu-toggle>
            <ion-menu-toggle autoHide="false" *ngIf="externalTopLink">
              <ion-item [href]="externalTopLink.link" target="_blank">
                <ion-icon src='data:image/svg+xml;utf8,<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="1024" height="768" viewBox="0 0 1024 768"><path d="M640 768H128V257.90599999999995L256 256V128H0v768h768V576H640V768zM384 128l128 128L320 448l128 128 192-192 128 128V128H384z"></path></svg>'></ion-icon>
                <ion-label class="ion-label">
                  {{externalTopLink.title}}
                </ion-label>
              </ion-item>
            </ion-menu-toggle>
          </ion-list>

          <ion-list>
            <ion-list-header>
              {{ 'sidemenu.account' | translate }}
            </ion-list-header>
            <ion-item>
              <ion-icon slot="start" name="contact"></ion-icon>
              <ion-label class="ion-label">
                {{ user.username }}
              </ion-label>
            </ion-item>
            <ion-menu-toggle autoHide="false">
              <ion-item button (click)="logout()" detail="false">
                <ion-icon slot="start" name="log-out"></ion-icon>
                <ion-label class="ion-label">
                  {{ 'sidemenu.logout' | translate }}
                </ion-label>
              </ion-item>
            </ion-menu-toggle>
          </ion-list>

          <div *ngIf="collectiveConfig" class="logos-menu">
            <ion-list *ngIf="collectiveConfig.logoesr" class="logo-esr" lines="none">
              <ion-item class="logo-img">
                <img src="{{ collectiveConfig.logoesr }}">
              </ion-item>
            </ion-list>

            <ion-list *ngIf="collectiveConfig.logoProvider" class="logo-alares" lines="none">
              <ion-item class="logo-text">
                <span>{{ 'sidemenu.provided' | translate }}</span>
              </ion-item>
              <ion-item class="logo-img">
                <img src="{{ collectiveConfig.logoProvider }}">
              </ion-item>
            </ion-list>
          </div>

      </ion-content>
    </ion-menu>
    <ion-router-outlet id="main-content" animated=true></ion-router-outlet>
  </ion-split-pane>
</ion-app>
